import { render, staticRenderFns } from "./AddAberrationDialog.vue?vue&type=template&id=7eb12aea"
import script from "./AddAberrationDialog.vue?vue&type=script&lang=ts"
export * from "./AddAberrationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports